<template>
  <div>
    <span>{{price}}</span>
  </div>
</template>

<script>

    import VsSelect from "../_framework/VsSelect";
    import BaseService from "../_framework/api/BaseService.js";
    import EventBus from "../bus.js";
    import axios from "axios";
    import Moment from "moment-jalali";

    export default {
        name: 'product-last-price',
        props: ['row'],
        components: {
            VsSelect
        },
        data() {
            return {
                price: ""
            }
        },
        mounted() {
            if (this.row  && this.row.stock) {
                this.price = this.row.stock.lastPrice;
            } else {
                this.price = "-"
            }

        }
    }

</script>

<style scoped lang="scss">

</style>
